import { createInertiaApp } from "@inertiajs/react"
import { createRoot } from "react-dom/client"

// Import all page components (esbuild doesn't support import.meta.glob)
import AuthLogin from "./Pages/Auth/Login"
import WorkspacesIndex from "./Pages/Workspaces/Index"
import WorkspacesShow from "./Pages/Workspaces/Show"
import WorkspacesNew from "./Pages/Workspaces/New"
import AgentsIndex from "./Pages/Agents/Index"
import AgentsShow from "./Pages/Agents/Show"
import AgentsNew from "./Pages/Agents/New"
import AgentsEdit from "./Pages/Agents/Edit"
import AccountEdit from "./Pages/Account/Edit"
import HistoryIndex from "./Pages/History/Index"

const pages = {
  "Auth/Login": AuthLogin,
  "Workspaces/Index": WorkspacesIndex,
  "Workspaces/Show": WorkspacesShow,
  "Workspaces/New": WorkspacesNew,
  "Agents/Index": AgentsIndex,
  "Agents/Show": AgentsShow,
  "Agents/New": AgentsNew,
  "Agents/Edit": AgentsEdit,
  "Account/Edit": AccountEdit,
  "History/Index": HistoryIndex,
}

createInertiaApp({
  resolve: (name) => {
    const page = pages[name]
    if (!page) {
      throw new Error(`Page not found: ${name}`)
    }
    return page
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
